import { IConfigData } from '@df/catalog/config/config.interfaces';
import { NICmsContentField } from '@icms/core/content';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
export const CMS_CONFIG_V12_RETAIL_FINANCE = 'v12-retail-finance';
export interface IICmsConfigV12RetailFinanceDataContent {
    valueFinanceMonth: number;
    valueFinancePercent: number;
    valueDepositPercent: number;
}
export interface IICmsConfigV12RetailFinanceData extends IConfigData<IICmsConfigV12RetailFinanceDataContent> {
}
ICmsContentService.registerConfig({
    id: CMS_CONFIG_V12_RETAIL_FINANCE,
    name: 'V12 Retail Finance configuration',
    fields: [
        {
            key: 'valueFinanceMonth',
            type: NICmsContentField.EFieldType.number,
            title: 'Value Finance Month',
            required: true
        },
        {
            key: 'valueFinancePercent',
            type: NICmsContentField.EFieldType.number,
            title: 'Value Finance Percent',
            required: true
        },
        {
            key: 'valueDepositPercent',
            type: NICmsContentField.EFieldType.number,
            title: 'Value Deposit Percent',
            required: true
        }
    ]
});
